export const BASE_URL = process.env.REACT_APP_API_BASE_URL;

// Updated to accept is247Filtered parameter for Google search
export const fetchRehabCenters = async (query, is247Filtered = false) => {
  try {
    let url = `${BASE_URL}/rehab-center/search?query=${encodeURIComponent(query)}`;
    if (is247Filtered) {
      url += `&googleOpen24Hours=true`;
    }
    const res = await fetch(url);
    if (!res.ok) throw new Error("Failed to fetch rehab center data from Google API via backend");
    return await res.json();
  } catch (error) {
    console.error("Fetch error (Google API via backend):", error);
    return { results: [] }; // Return structure expected by RehabCenterLocator
  }
};

export const fetchRehabCentersByLocation = async (lat, lng) => {
  try {
    const res = await fetch(
      `${BASE_URL}/rehab-center/nearby?lat=${lat}&lng=${lng}`
    );
    return await res.json();
  } catch (err) {
    console.error("Location fetch error:", err);
    return null;
  }
};

// Updated to accept is247Filtered parameter for local DB search
export const fetchLocalRehabCenters = async (query, is247Filtered = false) => {
  try {
    let url = `${BASE_URL}/rehab-center/local?query=${encodeURIComponent(
      query
    )}`;
    if (is247Filtered) {
      url += `&filterOpen24Hours=true`;
    }
    const res = await fetch(url);
    if (!res.ok)
      throw new Error("Local API response not ok for fetching local rehab centers");
    return await res.json();
  } catch (error) {
    console.error("Local search error (fetching local rehab centers):", error);
    return [];
  }
};

export const fetchLocalRehabCentersByCoords = async (
  lat,
  lng,
  is247Filtered = false
) => {
  try {
    let url = `${BASE_URL}/rehab-center/local-by-coords?lat=${lat}&lng=${lng}`;
    if (is247Filtered) {
      url += `&filterOpen24Hours=true`;
    }
    const res = await fetch(url);
    if (!res.ok)
      throw new Error(
        "Local API response not ok for fetching local rehab centers by coordinates"
      );
    return await res.json();
  } catch (error) {
    console.error(
      "Local search error (fetching local rehab centers by coords):",
      error
    );
    return [];
  }
};

export const fetchAllRehabCenters = async () => {
  try {
    const response = await fetch(`${BASE_URL}/rehab-center/admin/all`);
    return await response.json();
  } catch (err) {
    console.error("Error fetching rehab centers:", err);
    return [];
  }
};

export const updateRehabCenterStatus = async (id, status) => {
  try {
    const res = await fetch(`${BASE_URL}/rehab-center/admin/status/${id}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ status }),
    });
    return await res.json();
  } catch (err) {
    console.error("Failed to update status:", err);
    return null;
  }
};



export const updateRehabCenterDetails = async (updatedData) => {
  try {
    const response = await fetch(`${BASE_URL}/rehab-center/admin/update/${updatedData.id}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(updatedData),
    });

    return await response.json();
  } catch (error) {
    console.error("Error updating rehab center:", error);
    return { success: false, error };
  }
};